import { FOCO_VISIVEL } from 'utils/foco';

import { OpcaoDoFiltro } from '../selos-modelo';

const PILULA = `cursor-pointer rounded-jj-pill px-[22px] font-display text-[13px] font-bold uppercase tracking-[0.005em] ${FOCO_VISIVEL}`;
// Ativa em branco, e não no amarelo do design: amarelo sobre o azul fica em 4,44:1 (WCAG 1.4.3).
const PILULA_ATIVA = `${PILULA} border-0 bg-brand-blue py-[11px] text-brand-white`;
const PILULA_INATIVA = `${PILULA} border-2 border-solid border-brand-blue bg-brand-white py-[9px] text-brand-blue`;

interface FiltroDeCicloProps {
  /** `opcoesDoFiltro`: do ciclo mais recente ao mais antigo, e "Todos os ciclos" por último (AJ2-17). */
  opcoes: OpcaoDoFiltro[];
  filtro: string;
  onFiltro: (filtro: string) => void;
}

/** "Ciclo" e as pílulas (SEL-05, SEL-42). */
export default function FiltroDeCiclo({ opcoes, filtro, onFiltro }: FiltroDeCicloProps) {
  return (
    <div className="flex flex-wrap items-center gap-2.5">
      {/* `text-content`, e não o `text-soft` do design: 4,43:1 sobre o cinza da página. */}
      <span aria-hidden="true" className="font-display text-xs font-bold uppercase leading-[normal] tracking-[0.05em] text-content">
        Ciclo
      </span>
      <div role="group" aria-label="Filtrar selos por ciclo" className="flex flex-wrap items-center gap-2.5">
        {opcoes.map(opcao => (
          <button
            key={opcao.valor}
            type="button"
            aria-pressed={filtro === opcao.valor}
            onClick={() => onFiltro(opcao.valor)}
            className={filtro === opcao.valor ? PILULA_ATIVA : PILULA_INATIVA}
          >
            {opcao.rotulo}
          </button>
        ))}
      </div>
    </div>
  );
}
